import * as React from 'react';

const SvgHomeOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 22V8l9-6 9 6v14h-7v-6h-4v6H3Zm13-2h3V9.07L12 4.4 5 9.07V20h3v-6h8v6Z", fill: "currentColor" })));

export { SvgHomeOutline as default };
